// Includes only the "core" of graphlib
module.exports = {
  Graph: require("./graph"),
  version: require("./version")
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/graphlib/lib/index.js
// module id = 210
// module chunks = 0